/**
 * EnumPaymentStatus
 * @export EnumPaymentStatus
 * @enum 
 */


enum EnumPaymentStatus {
  All = 'All',
  PendingPayment = 'PendingPayment',
  WaitingAuth = 'WaitingAuth',
  Complete = 'Complete',
  NotForSale = 'NotForSale',
  Terminated = 'Terminated',
  Invalid = 'Invalid',
  Canceled = 'Canceled',
}

export default EnumPaymentStatus
